import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import pl from './locales/pl.json';
import en from './locales/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'pl',
    debug: false,
    resources: {
      pl: { translation: pl },
      en: { translation: en },
    },
    interpolation: { escapeValue: false },
    detection: {
      // querystring=?lang=pl/en — używane gdy Aurabase jest embedded w Sorto-CRM
      // (host przekazuje swój locale). Persistencja w localStorage żeby przy
      // react-router-navigacji bez query lang dalej był aktywny.
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'aurabase_lang',
      caches: ['localStorage'],
    },
  });

export default i18n;
